// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --corner-radius: 15px;
}
.MuiContainer-root {
  max-width: 1100px !important;
}

.ModeratorCommunitysList {
  display: flex;
  border-radius: 16px;
  box-shadow: 2px 2px 10px 2px #cccccc;
  flex-flow: row;
  padding: 17px 30px 18px 30px;
  overflow-x: scroll;
  scroll-behavior: smooth;
  gap: 30px;
  scrollbar-width: none;
}
.ModeratorCommunitysList::-webkit-scrollbar {
  display: none;
}

.CommunityCard {
  position: relative;
  border-radius: var(--corner-radius) !important;
  background-color: #efeeed !important;
  width: 100%;
  min-width: 220px;
  height: 135px;
  border: 2px solid #dee5ec;
}
.CommunityCard:hover {
  border: 2px solid #4795de !important;
}
.CommunityIcon {
  border-radius: var(--corner-radius);
  min-height: 105px;
}
.moderator-tab-1{
  margin-left: 55px !important;
  margin-right: 55px !important;
  outline: none !important;
  box-shadow: none !important;
  font-family: Arial, Helvetica, sans-serif;
}
.moderator-tab{
  margin-right: 55px !important;
  outline: none !important;
  box-shadow: none !important;
  font-family: Arial, Helvetica, sans-serif;
}

@media all and (max-width: 575px) {
  .moderator-tab {
    margin-right: 5px !important;
  }
  .moderator-tab-1 {
    margin-left: 5px !important;
    margin-right: 5px !important;
  }
}
@media all and (min-width: 576px) and (max-width: 768px) {
  .moderator-tab {
    margin-right: 20px !important;
  }
  .moderator-tab-1 {
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
}

.CommunityName {
  padding: 0px 8px 6px 9px !important;
  overflow: hidden;
}
.community-title{
  display: block;
  font-size: 14px;
  white-space: nowrap;     /* Don't wrap */
  overflow: hidden;        /* Hide extra text */
  text-overflow: ellipsis; /* Add ... */
}
.MuiCardContent-root:last-child {
  padding-bottom: 0;
}
.NewCommunity {
  background-color: #dee5ec;
  display: flex;
  justify-content: center;
  padding: 26px;
  height: 100px;
}
.ModerateNewCommunity {
  width: auto !important;
}

.ModeratorHeader {
  box-shadow: 0px 2px 4px #cccccc;
  border-radius: 20px;
}

.MiddleContent {
  display: flex;
  margin-top: 20px;
}

.menuItems {
  box-shadow: -2px -3px 6px #ffffff, 2px 3px 10px #00000029;
  border-radius: 20px;
  padding: 8px 20px 0 12px;
  width: 250px;
  line-height: 30px;
  height: -moz-fit-content;
  height: fit-content;
}
.menuItems ul {
  padding: 0;
  margin-bottom: 0.6rem;
}
.menuItems ul li {
  list-style-type: none;
  cursor: pointer;
  padding: 10px 0 5px 8px;
}
.menuItems ul li span {
  position: relative;
}
.menuItems ul li span img {
  padding-left: 10px;
}
.css-1gsv261 {
  border-bottom: 0 !important;
}
.css-1h9z7r5-MuiButtonBase-root-MuiTab-root {
  text-transform: capitalize !important;
}

.activityDropdownOption {
  display: none;
  position: absolute;
  box-sizing: border-box;
  box-shadow: 1px 2px 6px;
  background-color: #f3f2f0;
  border-radius: 10px;
  min-width: 193px;
  z-index: 2000;
  padding: 8px 8px;
}
.menuItems > ul > li:hover > .activityDropdownOption {
  display: block;
}

.MenuContent {
  background-color: #efeeed;
  box-shadow: 1px 2px 3px;
  margin: 0 16px 0 20px;
  border-radius: 20px;
  width: 100%;
  height: 577px;
  overflow-y: scroll;
  scroll-behavior: smooth;
  scrollbar-width: none;
}
.FirstOption {
  color: #4795de;
}
.action-item-count-container{
  display: flex;
}
.action-item-count {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 3px;               /* Add horizontal padding for spacing */
  margin-left: 8px;
  min-width: 20px;                /* Minimum width for small numbers */
  height: 20px;                   /* Fixed height */
  border-radius: 50px;            /* Keeps it rounded */
  background-color: #EF3F37;
  white-space: nowrap;            /* Prevents text from wrapping */
}
.action-item-count p {
  margin-bottom: 1.5px;
  font-size: 12px;
  color: white;
  font-weight: 800;          
}

.ModeratorIcon {
  position: absolute;
  left: 5px;
  top: 5px;
}
.AddPhotoInput {
  /* visibility: hidden */
  display: none;
}
.AddPhotoLabel {
  display: contents;
  cursor: pointer;
}
.Phototimeline-modal {
  max-width: 487px;
  background-color: #ffffff;
  border-radius: 25px;
}
.Phototimeline-modal-body {
  display: flex;
  align-items: center;
  justify-content: center;
}
.photo-preview {
  width: 100%;
  max-width: 427px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  color: rgba(0, 0, 0, 0.87);
  height: 100%;
  max-height: 248px;
}
.post-phototimeline-heading {
  font-size: 17px;
  font-weight: 600;
}
.photo-preview-description {
  resize: none;
  width: 100%;
  max-width: 427px;
  margin-top: 10px;
  border-radius: 10px;
}
.phototimeline-location-tag {
  display: flex;
  justify-content: space-between;
  padding: 0px 0 0 33px;
}
.Advanced-phototimelinewidth {
  max-width: 552px;
  background-color: #ffffff;
  border-radius: 25px;
}
.multifile-upload {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  scroll-behavior: smooth;
  overflow-y: scroll;
  max-height: 370px;
  scrollbar-width: none;
}
.multiphoto-preview {
  width: 100%;
  max-width: 255px;
  height: 100%;
  max-height: 143px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  color: rgba(0, 0, 0, 0.87);
}
.multi-photopreviewdescription {
  height: 100%;
  max-height: 72px;
}

.single-multi-phototimelineimage {
  display: block;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  object-fit: cover;
}
/* .modal-footer{
    border: none;
} */
.Multiphoto-addlink {
  position: absolute;
  left: 3rem;
}

.Delete-Photo-icon {
  position: absolute;
  right: 45px;
  top: 24px;
  padding: 1px 0 0 4.5px;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: #efeeed;
  border: 1px solid #fff;
  cursor: pointer;
}
.multiphoto-main {
  position: relative;
}
.multiphoto-delete {
  position: absolute;
  right: 6px;
  top: 6px;
  padding: 0px 0px 0px 3px;
  height: 28px;
  width: 28px;
  border-radius: 50%;
  background-color: #efeeed;
  border: 1px solid #fff;
}

.checked-delete-photo {
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
}

.DeleteTimeLineImage {
  display: none;
}
.blockuser-confirmbutton {
  background: white;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;

  cursor: text !important;
  -webkit-text-decoration: None !important;
          text-decoration: None !important;
}
/* Add custom styles for the ConfirmDialog */
.custom-confirm-dialog .p-dialog-content {
  text-align: center; /* Align text in the center */
  
}
.custom-confirm-dialog  {
  text-align: center; /* Align text in the center */
  border-radius: 50px
}

.custom-confirm-dialog .p-button {
  border-radius: 50px !important; /* Change the radius of the buttons */
}

`, "",{"version":3,"sources":["webpack://./src/Assets/css/Moderator/ModeratorHeader.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;AACF;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB,MAAM,eAAe;EACxC,gBAAgB,SAAS,oBAAoB;EAC7C,uBAAuB,EAAE,YAAY;AACvC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;EACzD,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,wBAAmB;EAAnB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,gBAAgB,uCAAuC;EACvE,gBAAgB;EAChB,eAAe,iBAAiB,oCAAoC;EACpE,YAAY,oBAAoB,iBAAiB;EACjD,mBAAmB,aAAa,qBAAqB;EACrD,yBAAyB;EACzB,mBAAmB,aAAa,gCAAgC;AAClE;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB;4EAC0E;EAC1E,6DAA6D;EAC7D,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB;4EAC0E;EAC1E,6DAA6D;EAC7D,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;AACnB;AACA;;GAEG;AACH;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;;EAEf,uBAAuB;EACvB,wCAAgC;UAAhC,gCAAgC;AAClC;AACA,4CAA4C;AAC5C;EACE,kBAAkB,EAAE,6BAA6B;;AAEnD;AACA;EACE,kBAAkB,EAAE,6BAA6B;EACjD;AACF;;AAEA;EACE,8BAA8B,EAAE,qCAAqC;AACvE","sourcesContent":[":root {\r\n  --corner-radius: 15px;\r\n}\r\n.MuiContainer-root {\r\n  max-width: 1100px !important;\r\n}\r\n\r\n.ModeratorCommunitysList {\r\n  display: flex;\r\n  border-radius: 16px;\r\n  box-shadow: 2px 2px 10px 2px #cccccc;\r\n  flex-flow: row;\r\n  padding: 17px 30px 18px 30px;\r\n  overflow-x: scroll;\r\n  scroll-behavior: smooth;\r\n  gap: 30px;\r\n  scrollbar-width: none;\r\n}\r\n.ModeratorCommunitysList::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.CommunityCard {\r\n  position: relative;\r\n  border-radius: var(--corner-radius) !important;\r\n  background-color: #efeeed !important;\r\n  width: 100%;\r\n  min-width: 220px;\r\n  height: 135px;\r\n  border: 2px solid #dee5ec;\r\n}\r\n.CommunityCard:hover {\r\n  border: 2px solid #4795de !important;\r\n}\r\n.CommunityIcon {\r\n  border-radius: var(--corner-radius);\r\n  min-height: 105px;\r\n}\r\n.moderator-tab-1{\r\n  margin-left: 55px !important;\r\n  margin-right: 55px !important;\r\n  outline: none !important;\r\n  box-shadow: none !important;\r\n  font-family: Arial, Helvetica, sans-serif;\r\n}\r\n.moderator-tab{\r\n  margin-right: 55px !important;\r\n  outline: none !important;\r\n  box-shadow: none !important;\r\n  font-family: Arial, Helvetica, sans-serif;\r\n}\r\n\r\n@media all and (max-width: 575px) {\r\n  .moderator-tab {\r\n    margin-right: 5px !important;\r\n  }\r\n  .moderator-tab-1 {\r\n    margin-left: 5px !important;\r\n    margin-right: 5px !important;\r\n  }\r\n}\r\n@media all and (min-width: 576px) and (max-width: 768px) {\r\n  .moderator-tab {\r\n    margin-right: 20px !important;\r\n  }\r\n  .moderator-tab-1 {\r\n    margin-left: 20px !important;\r\n    margin-right: 20px !important;\r\n  }\r\n}\r\n\r\n.CommunityName {\r\n  padding: 0px 8px 6px 9px !important;\r\n  overflow: hidden;\r\n}\r\n.community-title{\r\n  display: block;\r\n  font-size: 14px;\r\n  white-space: nowrap;     /* Don't wrap */\r\n  overflow: hidden;        /* Hide extra text */\r\n  text-overflow: ellipsis; /* Add ... */\r\n}\r\n.MuiCardContent-root:last-child {\r\n  padding-bottom: 0;\r\n}\r\n.NewCommunity {\r\n  background-color: #dee5ec;\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 26px;\r\n  height: 100px;\r\n}\r\n.ModerateNewCommunity {\r\n  width: auto !important;\r\n}\r\n\r\n.ModeratorHeader {\r\n  box-shadow: 0px 2px 4px #cccccc;\r\n  border-radius: 20px;\r\n}\r\n\r\n.MiddleContent {\r\n  display: flex;\r\n  margin-top: 20px;\r\n}\r\n\r\n.menuItems {\r\n  box-shadow: -2px -3px 6px #ffffff, 2px 3px 10px #00000029;\r\n  border-radius: 20px;\r\n  padding: 8px 20px 0 12px;\r\n  width: 250px;\r\n  line-height: 30px;\r\n  height: fit-content;\r\n}\r\n.menuItems ul {\r\n  padding: 0;\r\n  margin-bottom: 0.6rem;\r\n}\r\n.menuItems ul li {\r\n  list-style-type: none;\r\n  cursor: pointer;\r\n  padding: 10px 0 5px 8px;\r\n}\r\n.menuItems ul li span {\r\n  position: relative;\r\n}\r\n.menuItems ul li span img {\r\n  padding-left: 10px;\r\n}\r\n.css-1gsv261 {\r\n  border-bottom: 0 !important;\r\n}\r\n.css-1h9z7r5-MuiButtonBase-root-MuiTab-root {\r\n  text-transform: capitalize !important;\r\n}\r\n\r\n.activityDropdownOption {\r\n  display: none;\r\n  position: absolute;\r\n  box-sizing: border-box;\r\n  box-shadow: 1px 2px 6px;\r\n  background-color: #f3f2f0;\r\n  border-radius: 10px;\r\n  min-width: 193px;\r\n  z-index: 2000;\r\n  padding: 8px 8px;\r\n}\r\n.menuItems > ul > li:hover > .activityDropdownOption {\r\n  display: block;\r\n}\r\n\r\n.MenuContent {\r\n  background-color: #efeeed;\r\n  box-shadow: 1px 2px 3px;\r\n  margin: 0 16px 0 20px;\r\n  border-radius: 20px;\r\n  width: 100%;\r\n  height: 577px;\r\n  overflow-y: scroll;\r\n  scroll-behavior: smooth;\r\n  scrollbar-width: none;\r\n}\r\n.FirstOption {\r\n  color: #4795de;\r\n}\r\n.action-item-count-container{\r\n  display: flex;\r\n}\r\n.action-item-count {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 3px 3px;               /* Add horizontal padding for spacing */\r\n  margin-left: 8px;\r\n  min-width: 20px;                /* Minimum width for small numbers */\r\n  height: 20px;                   /* Fixed height */\r\n  border-radius: 50px;            /* Keeps it rounded */\r\n  background-color: #EF3F37;\r\n  white-space: nowrap;            /* Prevents text from wrapping */\r\n}\r\n.action-item-count p {\r\n  margin-bottom: 1.5px;\r\n  font-size: 12px;\r\n  color: white;\r\n  font-weight: 800;          \r\n}\r\n\r\n.ModeratorIcon {\r\n  position: absolute;\r\n  left: 5px;\r\n  top: 5px;\r\n}\r\n.AddPhotoInput {\r\n  /* visibility: hidden */\r\n  display: none;\r\n}\r\n.AddPhotoLabel {\r\n  display: contents;\r\n  cursor: pointer;\r\n}\r\n.Phototimeline-modal {\r\n  max-width: 487px;\r\n  background-color: #ffffff;\r\n  border-radius: 25px;\r\n}\r\n.Phototimeline-modal-body {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.photo-preview {\r\n  width: 100%;\r\n  max-width: 427px;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),\r\n    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\r\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  height: 100%;\r\n  max-height: 248px;\r\n}\r\n.post-phototimeline-heading {\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n}\r\n.photo-preview-description {\r\n  resize: none;\r\n  width: 100%;\r\n  max-width: 427px;\r\n  margin-top: 10px;\r\n  border-radius: 10px;\r\n}\r\n.phototimeline-location-tag {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 0px 0 0 33px;\r\n}\r\n.Advanced-phototimelinewidth {\r\n  max-width: 552px;\r\n  background-color: #ffffff;\r\n  border-radius: 25px;\r\n}\r\n.multifile-upload {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  scroll-behavior: smooth;\r\n  overflow-y: scroll;\r\n  max-height: 370px;\r\n  scrollbar-width: none;\r\n}\r\n.multiphoto-preview {\r\n  width: 100%;\r\n  max-width: 255px;\r\n  height: 100%;\r\n  max-height: 143px;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),\r\n    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\r\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\r\n  color: rgba(0, 0, 0, 0.87);\r\n}\r\n.multi-photopreviewdescription {\r\n  height: 100%;\r\n  max-height: 72px;\r\n}\r\n\r\n.single-multi-phototimelineimage {\r\n  display: block;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  width: 100%;\r\n  object-fit: cover;\r\n}\r\n/* .modal-footer{\r\n    border: none;\r\n} */\r\n.Multiphoto-addlink {\r\n  position: absolute;\r\n  left: 3rem;\r\n}\r\n\r\n.Delete-Photo-icon {\r\n  position: absolute;\r\n  right: 45px;\r\n  top: 24px;\r\n  padding: 1px 0 0 4.5px;\r\n  height: 30px;\r\n  width: 30px;\r\n  border-radius: 50%;\r\n  background-color: #efeeed;\r\n  border: 1px solid #fff;\r\n  cursor: pointer;\r\n}\r\n.multiphoto-main {\r\n  position: relative;\r\n}\r\n.multiphoto-delete {\r\n  position: absolute;\r\n  right: 6px;\r\n  top: 6px;\r\n  padding: 0px 0px 0px 3px;\r\n  height: 28px;\r\n  width: 28px;\r\n  border-radius: 50%;\r\n  background-color: #efeeed;\r\n  border: 1px solid #fff;\r\n}\r\n\r\n.checked-delete-photo {\r\n  position: absolute !important;\r\n  top: 0 !important;\r\n  right: 0 !important;\r\n}\r\n\r\n.DeleteTimeLineImage {\r\n  display: none;\r\n}\r\n.blockuser-confirmbutton {\r\n  background: white;\r\n  color: inherit;\r\n  border: none;\r\n  padding: 0;\r\n  font: inherit;\r\n  cursor: pointer;\r\n\r\n  cursor: text !important;\r\n  text-decoration: None !important;\r\n}\r\n/* Add custom styles for the ConfirmDialog */\r\n.custom-confirm-dialog .p-dialog-content {\r\n  text-align: center; /* Align text in the center */\r\n  \r\n}\r\n.custom-confirm-dialog  {\r\n  text-align: center; /* Align text in the center */\r\n  border-radius: 50px\r\n}\r\n\r\n.custom-confirm-dialog .p-button {\r\n  border-radius: 50px !important; /* Change the radius of the buttons */\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
